import React, { useContext } from 'react';
import { CrudContext, usePromise } from '@digital/ui';
import { getUsuarioInfo, Usuario } from '@app/api/usuario';
import Perfil from '../Perfil/PerfilForm';

interface UsuarioFormProps {
  onUpdate: () => void;
}

const UsuarioForm = (props: UsuarioFormProps) => {
  const { onUpdate } = props;
  const { selectedItem } = useContext(CrudContext);
  const [userInfo] = usePromise(
    () => (selectedItem ? getUsuarioInfo(selectedItem.id) : Promise.resolve(undefined)),
    [selectedItem],
    {} as Usuario,
  );

  return <Perfil selectedItem={userInfo} onUpdate={onUpdate} />;
};
export default UsuarioForm;
